import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { CRUMB_LABEL_KEY, NAME } from '../constants';
import { apiProvider } from '../api';

const filter = {
	VozidloId: null as number | null,
	NvSkladId: null as number | null,
	VyrazenPrp: null as number | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
